import { format, parseISO } from 'date-fns';

/** Today's date as an ISO `yyyy-MM-dd` string in local time (no time component). */
export function todayIso(): string {
	const now = new Date();
	const y = now.getFullYear();
	const m = String(now.getMonth() + 1).padStart(2, '0');
	const d = String(now.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
}

export function convertDateFormat(dateString: string, locale: string): string {
	const date = new Date(dateString);
	const formatter = new Intl.DateTimeFormat(locale, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
	return formatter.format(date);
}

const formatDate = (inputDate: string): string => {
	if (!inputDate) return '-';
	const parsedInputDate = parseISO(inputDate);
	return format(parsedInputDate, 'MMM do, yyyy');
};

export { formatDate };
